import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ncp_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('ncp_token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authApi = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  me: () => api.get('/auth/me'),
};

// Cruises (Agent)
export const cruiseApi = {
  getActive: () => api.get('/cruises'),
  search: (params) => api.post('/availability/search', params),
};

// Bookings (Agent)
export const bookingApi = {
  create: (data) => api.post('/bookings', data),
  getAll: (params) => api.get('/bookings', { params }),
  getOne: (id) => api.get(`/bookings/${id}`),
  cancel: (id) => api.put(`/bookings/${id}/cancel`),
  getStats: () => api.get('/agent/stats'),
};

// Invoices (Agent)
export const invoiceApi = {
  getAll: (params) => api.get('/agent/invoices', { params }),
  getOne: (id) => api.get(`/invoices/${id}`),
  downloadPdf: (id) => api.get(`/invoices/${id}/pdf`, { responseType: 'blob' }),
  getCreditSummary: () => api.get('/agent/credit-summary'),
};

// Admin APIs
export const adminApi = {
  // Stats
  getStats: () => api.get('/admin/stats'),
  
  // Cruises
  getCruises: () => api.get('/admin/cruises'),
  getCruise: (id) => api.get(`/admin/cruises/${id}`),
  createCruise: (data) => api.post('/admin/cruises', data),
  updateCruise: (id, data) => api.put(`/admin/cruises/${id}`, data),
  deleteCruise: (id) => api.delete(`/admin/cruises/${id}`),
  
  // Bookings
  getBookings: (params) => api.get('/admin/bookings', { params }),
  updateBooking: (id, data) => api.put(`/admin/bookings/${id}`, data),
  
  // Agents
  getAgents: (params) => api.get('/admin/agents', { params }),
  getAgentStats: () => api.get('/admin/agents/stats'),
  approveAgent: (agentId) => api.post('/admin/agents/approve', { agent_id: agentId }),
  suspendAgent: (agentId, reason) => api.post('/admin/agents/suspend', { agent_id: agentId, reason }),
  reactivateAgent: (agentId) => api.post('/admin/agents/reactivate', { agent_id: agentId }),
  changeAgentPassword: (agentId, newPassword) => api.post('/admin/agents/change-password', { agent_id: agentId, new_password: newPassword }),
  
  // Invoices
  getInvoices: (params) => api.get('/invoices', { params }),
  getInvoice: (id) => api.get(`/invoices/${id}`),
  createInvoice: (data) => api.post('/invoices', data),
  downloadInvoicePdf: (id) => api.get(`/invoices/${id}/pdf`, { responseType: 'blob' }),
  recordPayment: (invoiceId, data) => api.post(`/invoices/${invoiceId}/payments`, data),
  
  // Credit Reports
  getCreditReport: () => api.get('/admin/credit-report'),
  getAgentCreditDetail: (agentId) => api.get(`/admin/credit-report/${agentId}`),
};

// Seed data
export const seedApi = {
  seed: () => api.post('/seed'),
};

export default api;
